import { render, staticRenderFns } from "./SocialNetworkAdmin.vue?vue&type=template&id=edb3bb06&scoped=true&"
import script from "./SocialNetworkAdmin.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkAdmin.vue?vue&type=style&index=0&id=edb3bb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3bb06",
  null
  
)

export default component.exports